import React from 'react'

export const CARD = { background: '#ffffff', borderRadius: 16, boxShadow: '0 2px 10px rgba(45, 43, 69, 0.06)', padding: '18px 20px' }

export function SectionLabel({ number, children }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 9, margin: '2px 2px 12px' }}>
            <span
                style={{
                    width: 20,
                    height: 20,
                    borderRadius: 999,
                    background: '#5e639b',
                    color: '#ffffff',
                    fontSize: 12,
                    fontWeight: 800,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {number}
            </span>
            <span style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.2, textTransform: 'uppercase', color: '#8e8fb4' }}>{children}</span>
        </div>
    )
}
